export default "__VITE_ASSET__s402f$wr__"